<template>
<div class="main-body">
  <div class="card">
      <div class="card-body">
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">
                    Shipper Management <small class="text-muted">shippers</small>
                  </h4>
              </div><!--col-->
              <div class="col-sm-7">
                  <header-button></header-button>
              </div><!--col-->
          </div><!--row-->

          <div class="row mt-4">
              <div class="col">
                  <div class="table-responsive">
                      <table class="table">
                        <colgroup>
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="10%">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>No.</th>
                            <th>{{ $t('shipper.courier_name') }}</th>
                            <th>{{ $t('shipper.shipper_account') }}</th>
                            <th>{{ $t('shipper.shipper_id') }}</th>
                            <th>{{ $t('shipper.shipper_name') }}</th>
                            <th>{{ $t('shipper.address_line_1') }}</th>
                            <th>{{ $t('shipper.city') }}</th>
                            <th>{{ $t('shipper.postal_code') }}</th>
                            <th>{{ $t('shipper.country_code') }}</th>
                            <th>{{ $t('shipper.status') }}</th>
                            <th>{{ $t('shipper.operation') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(shipper, index) in shippers" :key="index">
                            <td>{{ index+1 }}</td>
                            <td>{{ shipper.courier_name }}</td>
                            <td>{{ shipper.shipper_account }}</td>
                            <td>{{ shipper.shipper_id }}</td>
                            <td>{{ shipper.shiper_name }}</td>
                            <td>{{ shipper.address_line1 }}</td>
                            <td>{{ shipper.city }}</td>
                            <td>{{ shipper.postal_code }}</td>
                            <td>{{ shipper.country_code }}</td>
                            <td>
                              <span class="badge badge-success" v-if="shipper.status">{{ $t('shipper.active') }}</span>
                              <span class="badge badge-secondary" v-else>{{ $t('shipper.in_active') }}</span>
                            </td>
                            <td>
                              <router-link :to="{ path: '/shipper/' + shipper.id + '/edit' }">
                                <CButton color="primary"><i class="fa fa-pencil"></i></CButton>
                              </router-link>
                               <CButton color="danger" @click.stop.prevent="handleDelete(shipper.id)"><i class="fa fa-trash"></i></CButton>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                  </div>
              </div><!--col-->
          </div><!--row-->
      </div><!--card-body-->
  </div><!--card-->
  <loading-panel v-if="showLoadingPanel"></loading-panel>
</div>
</template>

<script>
import HeaderButton from '@/views/components/shipper/HeaderButton'
import LoadingPanel from '@/components/LoadingPanel'

export default {
  name: 'Shippers',
  components: {
    HeaderButton,
    LoadingPanel
  },
  mounted () {
    this.axios.get('/delivery/shipper').then(response => {
      this.shippers = response.data
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      shippers: [],
      showLoadingPanel: false
    }
  },
  methods: {
    handleDelete (shiperId) {
      this.$swal({
        title: this.$t('operation.delete.title'),
        text: this.$t('operation.delete.text'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('operation.delete.confirm_button'),
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          this.showLoadingPanel = true
          this.axios.delete('/delivery/shipper/' + shiperId).then(() => {
            this.$router.push('/shipper')
          }).catch(error => {
            this.showLoadingPanel = false
            this.$swal({
              icon: 'error',
              title: error.data.message
            })
          })
        }
      })
    }
  }
}
</script>
